import { CircularProgress } from '@mui/material';
import { Suspense, lazy } from 'react';

const AgentCatalogPage = lazy(() => import('../features/catalog/pages/AgentCatalogPage'));
const AgentDetailPage = lazy(() => import('../features/detail/pages/AgentDetailPage'));

export function AgentCatalogRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="agents-suspense-fallback" />}>
      <AgentCatalogPage />
    </Suspense>
  );
}

export function AgentDetailRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="agents-suspense-fallback" />}>
      <AgentDetailPage />
    </Suspense>
  );
}
